import React from 'react';
import { useHistory } from 'react-router-dom';

import Header from 'components/AppBar';
import Loader from 'components/Loader';
import { Mobile, Desktop } from 'components/Responsive';
import ScreenHeader from 'components/ScreenHeader';
import useStoreTranslation from 'hooks/useStoreTranslation';
import { DashboardReportPeriod } from 'models/dashboardReports';

import DashboardReportList from './components/DashboardReportList';

interface Props {
  dashboardReports?: DashboardReportPeriod[];
  isLoading: boolean;
}

const DashboardReports = ({ dashboardReports, isLoading }: Props) => {
  const history = useHistory();
  const { t } = useStoreTranslation();

  return (
    <>
      <Mobile>
        <Header noGoBack rightIcon="/images/close.svg" rightAction={() => history.push('/dashboard')}>
          {t('dashboard.dashboardReports.headerTitle')}
        </Header>
      </Mobile>
      <Desktop>
        <ScreenHeader title={t('dashboard.dashboardReports.headerTitle')} />
      </Desktop>

      {isLoading ? <Loader fullScreen /> : <DashboardReportList data={dashboardReports} />}
    </>
  );
};

export default DashboardReports;
